export const getPlanFeaturesShort = (orgType = "operation") => {
  const isOperation = orgType === "operation";

  return {
    lite: [
      "Time Tracking",
      "Task Management",
      "Projects & Budgeting",
      "Client & Invoice",
      "Reporting & Dashboard",
      "Schedules (Coming Soon)",
      "Desktop App",
      "Mobile App",
      "Apps & Devices",
    ],
    standard: isOperation
      ? [
          "Team",
          "Scheduling",
          "Route Map Tracking",
          "Live Location Tracking",
          "Timesheets, Timesheets Approval",
          "Payroll",
          "Integrations",
          "Reports",
        ]
      : [
          "Scheduling",
          "Route Map Tracking",
          "Live Location Tracking",
          "Timesheets, Timesheets Approval",
          "Payroll",
          "Integrations",
          "Reports",
        ],
    elite: isOperation
      ? [
          "Projects",
          "Tasks with task approval",
          "Photo, audio Evidence Upload",
          "Task Notes - Unlimited",
        ]
      : [
          "Customers",
          "Jobs with job approval",
          "Photo, audio Evidence Upload",
          "Job Notes - Unlimited",
        ],
  };
};

export const getPlanFeatures = (orgType = "operation") => {
  const isOperation = orgType === "operation";

  return {
    solo: [
      "Time Tracking",
      "Task Management",
      "Projects & Budgeting",
      "Client & Invoice",
      "Reporting & Dashboard",
      "Schedules (Coming Soon)",
      "Desktop App",
      "Mobile App",
      "Apps & Devices",
    ],
    standard: isOperation
      ? [
          "Team",
          "Scheduling",
          "Route Map Tracking",
          "Live Location Tracking",
          "Timesheets",
          "Timesheets Approval",
          "Payroll",
          "Members",
          "Integrations",
          "Reports",
        ]
      : [
          "Scheduling",
          "Route Map Tracking",
          "Live Location Tracking",
          "Timesheets",
          "Timesheets Approval",
          "Payroll",
          "Members",
          "Integrations",
          "Reports",
        ],
    premium: [],
    elite: isOperation
      ? [
          "Projects",
          "Tasks",
          "Task Approval",
          "Photo Evidence Upload",
          "Audio Evidence Recording",
          "Task Notes - Unlimited",
        ]
      : [
          "Customers",
          "Jobs",
          "Job Approval",
          "Photo Evidence Upload",
          "Audio Evidence Recording",
          "Job Notes - Unlimited",
        ],
  };
};

export const planFeatures = {
  solo: [
    "Time Tracking",
    "Task Management",
    "Projects & Budgeting",
    "Client & Invoice",
    "Reporting & Dashboard",
    "Schedules (Coming Soon)",
    "Desktop App",
    "Mobile App",
    "Apps & Devices",
  ],
  standard: [
    "Team",
    "Scheduling",
    "Route Map Tracking",
    "Live Location Tracking",
    "Timesheets",
    "Timesheets Approval",
    "Payroll",
    "Members",
    "Integrations",
    "Reports",
  ],
  premium: [],
  elite: [
    "Customers",
    "Work Orders",
    "Jobs",
    "Job Approval",
    "Photo Evidence Upload",
    "Audio Evidence Recording",
    "Job Notes - Unlimited",
  ],
};

export const planFeaturesShort = {
  lite: [
    "Time Tracking",
    "Task Management",
    "Projects & Budgeting",
    "Client & Invoice",
    "Reporting & Dashboard",
    "Schedules (Coming Soon)",
    "Desktop App",
    "Mobile App",
    "Apps & Devices",
  ],
  standard: [
    "Team",
    "Scheduling",
    "Route Map Tracking",
    "Live Location Tracking",
    "Timesheets, Timesheets Approval",
    "Payroll",
    "Integrations",
    "Reports",
  ],
  elite: [
    "Customers",
    // "Work Orders",
    "Jobs with job approval",
    "Photo, audio Evidence Upload",
    "Job Notes - Unlimited",
  ],
};
